import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { paths } from 'src/routes/paths';
import { createTask } from 'src/api/kanbanModifyByValdo';
import { enqueueSnackbar } from 'notistack';
import * as planificationService from './planification.service';

// Action pour charger l'organisation existante

export const addFormation = createAsyncThunk('planification/addFormation', async (dataToAdd) => planificationService.addFormation(dataToAdd));

export const uploadImage = createAsyncThunk('planification/uploadImage', async ({ imageObject, cancelToken, pathCall }) => planificationService.uploadImage(imageObject, cancelToken, pathCall));

export const deleteFormation = createAsyncThunk('planification/delete', async (session_id) => planificationService.deleteFormations(session_id));

export const planificationSlice = createSlice({
  name: 'planification',
  initialState: {
    formation: {},
    userObject: {},
    passwordObject: {},
    isLoading: false,
    msg: '', // Remplace 'error' par 'msg'

    isAddingFormation: false,
    addFormationSuccess: false,

    updatePasswordSuccess: false,
    imageObjectGet: {},

    formationGetFromDelete: {},
    isFormationDeleting: false,
    deleteFormationSuccess: false,

    isUploadingImage: false,
    uploadImagedSuccess: false,

    isUpdatingProfil: false,
    isUpdatingProfilSuccess: false,
  },
  reducers: {
    initUsers: (state, action) => {
      state.userObject = { ...action.payload };
    },
    addFormations: (state, action) => {
      state.formation = { ...state.formation, ...action.payload };
    },
    initDeleteFormation: (state, action) => {
      state.formationGetFromDelete = { ...state.formationGetFromDelete, ...action.payload };
    },
    resetDataAfterRequete: (state) => {
      state.uploadImagedSuccess = false;
      state.isUploadingImage = false;
      state.isUpdatingProfilSuccess = false;
      state.isUpdatingProfil = false;
      state.isAddingFormation = false;
      state.addFormationSuccess = false;

      state.deleteFormationSuccess = false;
      state.isFormationDeleting = false;
      state.formationGetFromDelete = {};

      state.isLoading = false; // Optionnel : réinitialiser l'état de chargement si nécessaire
      state.userObject = {};

      // console.log('reset appeler', state.deleteFormationSuccess);
    },
  },

  extraReducers: (builder) => {
    // Cas pour l'ajout d'une formation
    builder
      .addCase(addFormation.pending, (state) => {
        state.isAddingFormation = true;
        state.addFormationSuccess = false;
      })
      .addCase(addFormation.fulfilled, (state, action) => {
        state.isAddingFormation = false;
        state.addFormationSuccess = true;
        enqueueSnackbar('Formation ajoutée avec succès !');
        // console.log('Utilisateur ajouté avec succès:', action.payload);
        // Ajoutez les données utilisateur dans l'état si nécessaire
        state.formation = { ...state.formation, ...action.payload };
      })
      .addCase(addFormation.rejected, (state, action) => {
        state.isAddingFormation = false;
        state.addFormationSuccess = false;
        state.msg = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log("Erreur lors de l'ajout de l'utilisateur:", state.msg);
      });

    builder
      .addCase(deleteFormation.pending, (state) => {
        state.isFormationDeleting = true;
        state.deleteFormationSuccess = false;
        // console.log('suppression en cour:');
      })
      .addCase(deleteFormation.fulfilled, (state, action) => {
        state.isFormationDeleting = false;
        state.deleteFormationSuccess = true;
        state.formationGetFromDelete = {
          ...state.formationGetFromDelete,
          ...action.payload,
        };
        // console.log('formation supprimée avec succès:', action.payload);
      })
      .addCase(deleteFormation.rejected, (state, action) => {
        state.isFormationDeleting = false;
        state.deleteFormationSuccess = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log("Erreur lors de la supression de l'intervenant:", state.error);
      });

    // Cas pour l' upload des images'
    builder
      .addCase(uploadImage.pending, (state) => {
        state.isUploadingImage = true;
        state.uploadImagedSuccess = false;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.isUploadingImage = false;
        state.uploadImagedSuccess = true;
        // console.log('image uploader avec succès:', action.payload);
        // enqueueSnackbar( 'image uploader avec succès' );
        state.imageObjectGet = { ...state.imageObjectGet, ...action.payload };
        // console.log( state.imageObjectGet );
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.isUploadingImage = false;
        state.uploadImagedSuccess = false;
        state.msg = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log("Erreur lors de l'upload de l'image", action.data);
        // console.log("Message de l'Erreur:", state.msg);
      });
  },
});

// Exportation des actions et du reducer
export const { initUsers, addFormations, initDeleteFormation, resetDataAfterRequete } = planificationSlice.actions;
export default planificationSlice.reducer;
